import React from 'react';
import { Helmet } from 'react-helmet';
import { ROUTES } from '../../lib/constants';
import styles from './CurrentServiceAreas.module.scss'
import { Banner } from '../../components/Banner/Banner';
import tustinImageM from '../../images/construction-tustin-map-m.jpg';
import tustinImageD from '../../images/construction-tustin-map-d.jpg';
import danaPointImageM from '../../images/construction-danapt-map-m.jpg';
import danaPointImageD from '../../images/construction-danapt-map-d.jpg';
import { Image } from '../../components/Image/Image';


export const CurrentServiceAreas = (): React.JSX.Element => {
  
  return (
    <>
      <Helmet>
        <title>{ROUTES.currentServiceAreas.title}</title>
      </Helmet>

      <div className='grid-12' style={{ overflow: 'visible'}}>
        <section className={styles.container}>
          <h1 className='headline__h1 color--marina-blue'>
            Current Service Areas
          </h1>

          <div className={styles.legend}>
            <div>Under Construction</div>
            <div>2023 Construction</div>
            <div>2024 Construction</div>
          </div>

          <div className={styles.areas}>
            <div className={styles.area}>
              <h2 className='headline__h2 color--marina-blue'>
                Tustin
              </h2>
              <div className={styles.imgWrap}>
                <Image 
                  sources={[
                    {
                      src: tustinImageM,
                      breakpoint: 'default'
                    },
                    {
                      src: tustinImageD,
                      breakpoint: '720px'
                    }
                  ]}
                  alt='map of Tustin service area'
                />
                {/* <picture>
                  <source media="(min-width: 720px)" srcSet={tustinImageD} />
                  <img
                    src={tustinImageM}
                    alt='map of Tustin service area'
                    title='map of Tustin service area'
                    aria-label='map of Tustin service area'
                    width="100"
                    height="100"
                    loading="lazy"
                  />
                </picture> */}
              </div>
            </div>

            <div className={styles.area}>
              <h2 className='headline__h2 color--marina-blue'>
                Dana Point
              </h2>
              <div className={styles.imgWrap}>
                <picture>
                  <source media="(min-width: 720px)" srcSet={danaPointImageD} />
                  <img
                    src={danaPointImageM}
                    alt='map of Dana Point service area'
                    title='map of Dana Point service area'
                    aria-label='map of Dana Point service area'
                    width="100"
                    height="100"
                    loading="lazy"
                  />
                </picture>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className={styles.wavesWrap}>
        <div className={styles.waves}></div>
      </div>

      <Banner 
        headline='Experience the future of internet connectivity.'
        text='Connect with us today to explore the possibilities of high-speed internet for your home or business.'
        btnText='Check Availability'
        btnLink={ROUTES.checkAvailability.path}
        className={styles.banner}
      />
    </>
  )
}